import { useQuery } from '@tanstack/react-query';

import { postCompanyQuestion } from './fetchPostCompanyQuestion';
import { useGetApplicationQuery } from '../lendingApi/lendingApiQueries';

export function useGetCompanyQuestion({ enabled }: { enabled?: boolean }) {
  const { application } = useGetApplicationQuery();

  const { data, isLoading } = useQuery({
    queryKey: ['fetchGetCompanyQuestion', application?.application_id],
    queryFn: () =>
      postCompanyQuestion({
        applicationId: application?.application_id as string,
        data: {
          context: {},
          history: [],
        },
      }),
    enabled: enabled && Boolean(application?.application_id),
  });

  return {
    initialQuestion: data?.inference_question,
    isInitialCompanyQuestionLoading: isLoading,
  };
}
